var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('router-link',{attrs:{"to":{ name: 'login' }}},[_c('img',{staticClass:"nativoLogo",style:(_vm.loginLogoStyle),attrs:{"src":_vm.loginLogo}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }